import { Pipe, PipeTransform } from '@angular/core';
import { CLASSIFICATIONS_TYPES } from '@app/pages/cmms/components/shared-form-group-controls/cmms-classification/classification-types';

@Pipe({
	name: 'classificationName',
})
export class ClassificationNamePipe implements PipeTransform {
	transform(value: string): any {
		CLASSIFICATIONS_TYPES.find(item => {
			if (item.type === value) {
				return item.name;
			}
		});
		return value;
	}
}
